import { useGetStatsQuery } from '@platform/state/api';
import type { IListViewState, IRecordListParams, IRecordTypeDefinition } from '@platform/core/types';
import { quickCountParams } from './quickCountParams';

/**
 * Лічильники варіантів швидкого фільтра (прототип v4: «Усі записи · 471», «Призначені мені · 0»…) — `total` статистики з умовами варіанта (QF).
 * Без `domain` — по всіх записах типу, як на сторінці модуля прототипу (пункт меню лише звужує список); з `domain` — у множині сторінки-списку
 * (розділ «Проєктування»: «Усі записи · 6»). «Усі» без множини — той самий запит, що й лічильники статусів лівого меню (спільний кеш).
 * Поки статистика вантажиться чи недоступна — undefined (варіант без числа).
 */
export function useQuickCounts(
  ws: string, rt: IRecordTypeDefinition, domain?: Pick<IRecordListParams, 'filter' | 'preset'>,
): Record<IListViewState['quickFilter'], number | undefined> {
  const stats = (quick: IListViewState['quickFilter']) => ({ ws, rt: rt.key, by: 'status', params: quickCountParams(quick, rt, domain) });
  const all = useGetStatsQuery(stats('all')).data?.total;
  const mine = useGetStatsQuery(stats('mine')).data?.total;
  const open = useGetStatsQuery(stats('open')).data?.total;
  const overdue = useGetStatsQuery(stats('overdue')).data?.total;
  return { all, mine, open, overdue };
}
